<template>
  <v-card flat>
    <v-card-text>
      <v-layout wrap>
        <v-flex
          sm12
          xs12
          md4
          lg4>
          <material-card
            color="primary"
            title="Shift Details"

          >

            <dl>
              <dt v-if="showSupplier" ><span style="font-weight:bold">Supplier:</span>{{ recap.client_name }}</dt>
              <dt><span style="font-weight: bold">Location:</span> {{ recap.storename }}</dt>
              <dt><span style="font-weight: bold">Store #:</span> {{ recap.warehouse_id }}</dt>
              <dt><span style="font-weight: bold">Date:</span> {{ formatDate(recap.timesheet_date) }} {{ formatTime(recap.time_start) }} - {{ formatTime(recap.time_end) }}</dt>
              <dt><span style="font-weight: bold">Hours:</span> {{ recap.hours }} </dt>
              <dt v-if="recap.work_order"><span style="font-weight: bold">Work order:</span> {{ recap.work_order }}</dt>
              <dt><span style="font-weight: bold">Event Type:</span> {{ recap.sub_name }} </dt>
            </dl>
          </material-card>

          <material-card
            title="Comments"
            color="primary">
            {{ recap.comments }}
          </material-card>

          <material-card
            title="Store Details"
            color="primary">
            <dl>
              <dt
                v-if= "recap.adequate_product == 'no'"
                class="text-danger"
                style="font-weight:bold"><span style="font-weight: bold">Adequate Product:</span> {{ recap.adequate_product }}</dt>
              <dt v-if= "recap.adequate_product == 'yes'" ><span style="font-weight: bold">Adequate Product:</span> {{ recap.adequate_product }}</dt>
              <dt><span style="font-weight: bold">Department Staffed:</span> {{ recap.department_staffed }}</dt>
              <dt><span style="font-weight: bold">Checked In With:</span> {{ recap.check_in_name }}</dt>
            </dl>
          </material-card>

          <material-card
            title="Event Details"
            color="primary">
            <dl>
              <dt><span style="font-weight: bold">Shoppers Engaged:</span> {{ number(recap.how_many_customers) }}</dt>
              <dt><span style="font-weight: bold">Where:</span> {{ recap.conducted_where }}</dt>
              <dt v-if="recap.coupons=='yes'"><span style="font-weight: bold">Coupons:</span> {{ recap.coupons }}</dt>
              <dt v-if="recap.agency_name"><span style="font-weight: bold">Agency:</span> {{ recap.agency_name }}</dt>
              <dt v-if="recap.producer_name"><span style="font-weight: bold">Brand:</span> {{ recap.producer_name }}</dt>
            </dl>

          </material-card>
        </v-flex>

        <v-flex
          sm12
          xs12
          md8
          lg8>

          <material-card
            color="primary"
            title="Sales">
            <v-data-table
              :headers="((recap.includes_packs)? sales_headers : sales_headers_nopack)"
              :items="recap.winesold"
              class="elevation-1"
              item-key=""
              hide-actions
            >
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="text--darken-3"
                  v-text="header.text"
                />
              </template>

              <template
                slot="items"
                slot-scope="wines">
                <td>{{ wines.item.name }}</td>
                <td class="text-xs-right">{{ number(wines.item.samples) }}</td>
                <td class="text-xs-right">{{ number(wines.item.bottles_sold) }}</td>
                <td
                  v-if="recap.includes_packs == 1"
                  class="text-xs-right">{{ wines.item.packs_sold == null || wines.item.packs_sold === '' ? '' : number(wines.item.packs_sold) }}</td>
                <td class="text-xs-right">${{ Number(wines.item.unit_price || 0).toFixed(2) }}</td>
                <td class="text-xs-right">{{ wines.item.bottles_start == null ? '' : number(Number(wines.item.bottles_start) / (Number(wines.item.bottles_per_unit) || 1)) }}</td>
              </template>
            </v-data-table>

          </material-card>

          <material-card
            color="primary"
            title="Photos">
            <v-container
              fluid
              grid-list-md>
              <v-layout
                row
                wrap>
                <v-flex
                  v-for="photo in recap.photos"
                  :key="photo.uid"
                  xs6
                >
                  <v-card>
                    <a
                      :href="photo.url"
                      target="_blank"
                      rel="noopener noreferrer">
                      <span v-if="photo.file_type === 'pdf'">View PDF</span>
                      <v-img
                        v-else
                        :src="photo.url"
                        alt="Event photo"
                        class="grey lighten-2" />
                    </a>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>

          </material-card>

        </v-flex>
        <v-flex
          sm12
          xs12
          md4
          lg4/>
        <v-flex
          sm12
          xs12
          md8
          lg8/>

        <v-flex
          sm12
          xs12
          md4
          lg4/>
        <v-flex
          sm12
          xs12
          md4
          lg4/>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    recap: { type: Object, required: true },
    showSupplier: { type: Boolean, default: false }
  },
  data: () => ({
    sales_headers: [
      {
        sortable: false,
        text: 'Wine',
        value: 'wine_name'
      },
      {
        sortable: false,
        text: 'Samples',
        value: 'samples',
        align: 'right'
      },
      {
        sortable: false,
        text: 'Units',
        value: 'bottles_sold',
        align: 'right'
      },
      {
        sortable: false,
        text: 'Packs',
        value: 'packs_sold',
        align: 'right'
      },
      {
        sortable: false,
        text: 'Price',
        value: 'retail_price',
        align: 'right'
      },
      {
        sortable: false,
        text: 'IOH start',
        value: 'bottles_start',
        align: 'right'
      }
    ],
    sales_headers_nopack: [
      {
        sortable: false,
        text: 'Wine',
        value: 'wine_name'
      },
      {
        sortable: false,
        text: 'Samples',
        value: 'samples',
        align: 'right'
      },
      {
        sortable: false,
        text: 'Bottles',
        value: 'bottles_sold',
        align: 'right'
      },
      {
        sortable: false,
        text: 'Price',
        value: 'retail_price',
        align: 'right'
      },
      {
        sortable: false,
        text: 'IOH start',
        value: 'bottles_start',
        align: 'right'
      }
    ]
  }),
  methods: {
    number (value) {
      return Number(value || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    formatTime (time) {
      if (!time) return ''
      const [hour, minute] = time.split(':')
      return `${Number(hour) % 12 || 12}:${minute} ${Number(hour) < 12 ? 'AM' : 'PM'}`
    }
  }
}
</script>
